import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { DialogService, LogService, UtilService, NotificationService } from '../index';
import { Error } from '../model/error.model';

@Injectable()
export class ExceptionService implements ErrorHandler {
  public _logService: LogService;
  //public _dialogService: DialogService;
  public _utilService: UtilService;
  public _notifyService: NotificationService;

  constructor(logService: LogService, utilService: UtilService, notifyService: NotificationService) {
    this._logService = logService;
    //this._dialogService = dialogService;
    this._utilService = utilService;
    this._notifyService = notifyService;
  }

  handleError(err: any) {
    this._logService.error("Error: " + err);
    if (this._utilService.isNotNullOrUndefined(err)) {
      let logError = '';
      if (this._utilService.isNotNullOrUndefined(err.message)) {
        logError += err.message;
      }
      if (this._utilService.isNotNullOrUndefined(err.stack)) {
        logError += '  ' + err.stack;
      }
      if (this._utilService.isNullEmptyOrWhitespace(logError)) {
        logError = err.toString();
      }
      if (this._utilService.isNotNullEmptyOrWhitespace(logError)) {
        this._logService.error(logError);
      }

      if (this._utilService.isNotNullOrUndefined(err.rejection)) {
        if (this._utilService.isNotNullOrUndefined(err.rejection.Message)) {
          //this._dialogService.error(err.rejection.Message);
          this._notifyService.error(err.rejection.Message);
          if (this._utilService.isNotNullOrUndefined(err.rejection.ExceptionMessage)) {
            this._logService.error(err.rejection.ExceptionMessage);
          }
        } else if (this._utilService.isNotNullOrUndefined(err.rejection.message)) {
          this._logService.error(err.rejection.message);
        } else {
          this._logService.error(err.rejection.toString());
        }
      }
    }
  }
}
